var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.txt)+" "),_c('div'),_c('button',{on:{"click":_vm.onCopyClick}},[_vm._v("复制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }